import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Button } from './ui/button';
import { Heart, HeartOff } from 'lucide-react';
import { toast } from 'sonner';

export default function FollowVenueButton({ venueId, compact = false }) {
  const [following, setFollowing] = useState(false);
  const [count, setCount] = useState(null);

  useEffect(() => {
    if (!venueId) return;
    const load = async () => {
      const token = localStorage.getItem('token');
      try {
        const [c, mine] = await Promise.all([
          axios.get(`${API}/venue/followers/${venueId}`),
          token
            ? axios.get(`${API}/patron/following`, { headers: { Authorization: `Bearer ${token}` } })
            : Promise.resolve({ data: { venue_ids: [] } }),
        ]);
        setCount(c.data.followers);
        setFollowing(c.data.followers > 0 && (mine.data.venue_ids || []).includes(venueId));
      } catch { /* silent */ }
    };
    load();
  }, [venueId]);

  const toggle = async (e) => {
    if (e) { e.stopPropagation(); e.preventDefault(); }
    const token = localStorage.getItem('token');
    if (!token) { toast.error('Please log in to follow venues'); return; }
    try {
      const res = await axios.post(`${API}/patron/follow-venue`,
        { venue_id: venueId },
        { headers: { Authorization: `Bearer ${token}` } });
      setFollowing(res.data.following);
      setCount(c => (c == null ? c : c + (res.data.following ? 1 : -1)));
      toast.success(res.data.following ? '💚 Following' : 'Unfollowed');
    } catch (err) {
      toast.error('Failed');
    }
  };

  return (
    <Button
      data-testid={`follow-venue-${venueId}`}
      onClick={toggle}
      size={compact ? 'sm' : 'default'}
      variant={following ? 'default' : 'outline'}
      className={compact ? 'text-xs h-7 px-2' : 'text-sm'}
      style={{
        background: following ? '#00FF41' : 'transparent',
        color: following ? '#000' : '#00FF41',
        borderColor: '#00FF41',
        boxShadow: following ? '0 0 10px #00FF41' : 'none',
      }}
    >
      {following ? (
        <><Heart className="w-3 h-3 mr-1" fill="currentColor" /> Following ✓</>
      ) : (
        <><HeartOff className="w-3 h-3 mr-1" /> Follow</>
      )}
    </Button>
  );
}
